import React, { useEffect } from "react";
import PageFooter from "../components/shared/footer/PageFooter";
import PageHeader from "../components/shared/header/PageHeader";
import { useIsAuthenticated } from "@azure/msal-react";
import HamburgerMenuDesktopApp from "../components/shared/hamburgerMenuDesktopApp/hamburgerMenuDesktopApp";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { routePath } from "../constants/Routes";
import { UserEnrolledDevicesServiceInit } from "../store/UserEnrolledDevices/UserEnrolledDevicesSlice";
import { useDispatch } from "react-redux";

const CustomerLayout = ({children, isSubscribed = false}) => {
    const isAuthenticated = useIsAuthenticated();
    const currentURL = useLocation();
    const dispatch = useDispatch();
    const isDashboardPage = () => {
        return (currentURL?.pathname === routePath.DASHBOARD || currentURL?.pathname === routePath.MY_DEVICES || currentURL?.pathname === routePath.MANAGE_ADDRESS ) ? true : false;
    }
    const isNotificationCenterPage = () => {
        return (currentURL?.pathname === routePath.NOTIFICATION_CENTER ) ?  true : false;
    }
    const isOrderHistoryPage = () => {
        return (currentURL?.pathname === routePath.ORDERS) ?  true : false;
    }

    const isConnectDevicePage = () => {
        return (currentURL?.pathname === routePath.CONNECT_DEVICE_DASHBOARD ) ?  true : false;
    }
    const location = useLocation();
    const isDashboard = location.pathname === routePath.DASHBOARD 

    useEffect(() => {    
        // While redirecting to dashboard it is recommeded to call fresh GetUserEnrolledDevices API without 
        // depending on the call made during signin/sign up journey
        if(isDashboard){
            dispatch(UserEnrolledDevicesServiceInit());
        }
      }, [isDashboard, dispatch]);
  
    return (
        <>
            <PageHeader isSubscriptionCompletedRoute={isSubscribed} WebHeaderCName={(isSubscribed) ? 'post-enrollment-header' : 'pre-enrollment-header'}/>
                <div className={`${(isSubscribed && !isConnectDevicePage()) ? 'post-enrollment-wrapper' : 'pre-enrollment-wrapper'}`}>
                    {( isAuthenticated &&  isSubscribed && !isConnectDevicePage() ) ? 
                    <div className="hamburger-menu-desktop-container"><HamburgerMenuDesktopApp /></div>
                      : null} 
                    <div className={`${(isSubscribed) ?  ( ( isDashboardPage()||isNotificationCenterPage() || isOrderHistoryPage() )? 'postenrollment-pages-content-wrapper-full-width' : 'postenrollment-pages-content-wrapper-centre-positioning') : 'preenrollment-pages-content-wrapper'}`}>
                        {children} 
                    </div>
                </div>
            {!isAuthenticated && !isSubscribed &&
            <PageFooter cname={(isSubscribed) ? 'post-enrollment-footer' : 'pre-enrollment-footer'}/>
            }
        </>
    )
}

export default CustomerLayout;